import {
  Box,
  createStyles,
  makeStyles,
  Theme,
  Typography,
  useTheme,
} from "@material-ui/core";
import Chart from "chart.js";
import React, { useEffect, useRef } from "react";
import { PROGRESS_TYPE_LABELS } from "utils/jobDetailsUtils";

interface EstimatedProgressChartProps {
  currentHours: number;
  progress: number;
  totalHours: number;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    label: {
      color: theme.palette.primary.dark,
    },
    labelHours: {
      color: theme.palette.primary.dark,
      fontWeight: 600,
    },
    percentage: {
      color: theme.palette.primary.dark,
      fontWeight: 600,
      marginBottom: "4px",
    },
  }),
);

export function LaborProgressChart({
  currentHours,
  progress,
  totalHours,
}: EstimatedProgressChartProps) {
  const chartCanvasRef = useRef({} as HTMLCanvasElement);
  const classes = useStyles();
  const theme = useTheme();

  useEffect(() => {
    const isOvertime = progress > 100.0;

    new Chart(chartCanvasRef.current, {
      data: {
        datasets: [
          {
            backgroundColor: isOvertime
              ? theme.palette.error.main
              : [theme.palette.success.light, theme.palette.grey[200]],
            borderWidth: 0,
            data: isOvertime ? [progress] : [progress, 100.0 - progress],
            label: PROGRESS_TYPE_LABELS.LABOR,
          },
        ],
      },
      options: {
        animation: {
          animateRotate: true,
        },
        aspectRatio: 1,
        cutoutPercentage: 85,
        hover: {
          mode: undefined,
        },
        tooltips: {
          enabled: false,
        },
      },
      type: "doughnut",
    });
  }, [progress, theme]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      flexDirection="column"
      margin="0 auto"
      maxWidth="175px"
      position="relative"
    >
      <canvas ref={chartCanvasRef} />
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        height="50%"
        justifyContent="center"
        left="25%"
        position="absolute"
        top="25%"
        width="50%"
      >
        <Typography
          className={classes.percentage}
          variant="h5"
        >{`${progress}%`}</Typography>
        <Typography align="center" className={classes.label} variant="body2">
          {PROGRESS_TYPE_LABELS.LABOR.split(" Progress")[0]}
        </Typography>
        <Typography
          align="center"
          className={classes.labelHours}
          variant="body2"
        >
          {`${currentHours}/${totalHours}`}
        </Typography>
      </Box>
    </Box>
  );
}
